module.exports = __webpack_public_path__ + "media/images/athletes/3519-601b4e3c8f729a5738945b1a47e683f6.png";